// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "pre[data-v-32a0d82c]{outline:1px solid #ccc;padding:5px;margin:5px;background-color:#282828;color:#fff}.string[data-v-32a0d82c]{color:green!important}.number[data-v-32a0d82c]{color:#ff8c00!important}.boolean[data-v-32a0d82c]{color:#00f!important}.null[data-v-32a0d82c]{color:#f0f!important}.key[data-v-32a0d82c]{color:red!important}", ""]);
// Exports
module.exports = exports;
